<div class="null_state" *ngIf="(possible_contacts?.length !== 0 || fromPeoplePicker) && !isInviting">
    To add someone to the workforce, enter their email and details below.<br /><br />
</div>
<div class="back" [ngClass]="{inPeoplePicker: fromPeoplePicker}" (click)="onClickDispatchStatus('email_address')" *ngIf="newWorkerStatus === newWorkerStages.send_invite"><icon matIcon="keyboard_arrow_left"></icon> Back</div>
<div class="adding_worker" *ngIf="newWorkerStatus">
    <form #addForm="ngForm" autocomplete="off" *ngIf="!isInviting">
        <mat-form-field class="general">
            <input matInput autocomplete="off"  name="email" [pattern]="EMAIL_REGEX" [ngModel]="newWorker?.email" #email="ngModel" #emailEl [placeholder]="interchange_placeholder" (keyup)="isEmailEmpty($event, email.value)" (paste)="isEmailEmptyWithAPasteDelay($event)" [required]="possible_contacts.length === 0" [email]="possible_contacts.length === 0" />
        </mat-form-field>
        <div *ngIf="(newWorkerStatus === newWorkerStages.email_address || contacts.length == 0) && possible_contacts.length == 0">
            <mat-form-field class="general" >
                <input #firstName matInput autocomplete="off" name="firstName" [ngModel]="newWorker?.firstName"
                (keyup)="checkName(firstName.value, lastName.value)" (change)="changeInput($event, 'firstName')" placeholder="First Name" required/>
            </mat-form-field>
            <mat-form-field  class="general" >
                <input #lastName matInput autocomplete="off" name="lastName" [ngModel]="newWorker?.lastName" (keyup)="checkName(firstName.value, lastName.value)" (change)="changeInput($event, 'lastName')" placeholder="Last Name" required/>
            </mat-form-field>
        </div>
    </form>
    <div *ngIf="possible_contacts.length > 0 && !isInviting" class="possibles">
        <div class="title">CONTACTS</div>
        <div class="possible_contact"
          [ngClass]="{selected:selectedContacts.has(possible_contact.email)}"
          (click)="toggleContactChecked(possible_contact)"
          *ngFor="let possible_contact of possible_contacts; index as idx "
          >
            <div class="contact_name">
                <div>
                    <span *ngIf="possible_contact.firstName">{{possible_contact.firstName}}</span>
                    <span *ngIf="possible_contact.firstName && possible_contact.lastName">&nbsp;</span>
                    <span *ngIf="possible_contact.lastName">{{possible_contact.lastName}}</span>
                    <span>&nbsp; ({{possible_contact.email}})</span>
                </div>
               <div class="contact_account_title" *ngIf="possible_contact.accountId">
                    {{ public_account_info[possible_contact.accountId]?.title}}
                </div> <!--   NO WAY TO ACCESS account.accounts atm -->
                <div class="company_name" *ngIf="possible_contact.company && possible_contact.company != ''">
                    {{possible_contact.company}}
                </div>
            </div>
            <div style="flex-grow:1;"></div>
            <icon icon="tick_24px"></icon>
        </div>
    </div>
    <div class="no_contacts_found" *ngIf="newWorkerStatus === newWorkerStages.init && possible_contacts.length == 0 && !email_is_empty && contacts.length > 0">
        We can't find anyone in your contacts matching this entry. Please fill out an email address for this user.
    </div>
    <div *ngIf="isInviting">
        <div class="to_entry">
            <div *ngIf="newWorker?.email && !selectedContacts.size">
                <b>{{newWorker?.firstName}} {{newWorker?.lastName}}</b>&nbsp;
                <span>({{newWorker?.email}})</span>
            </div>
        </div>

      <div class="privileges_container">
        <div class="privileges_heading" *ngIf="workforceService.invite_as_account_role">
          <div><b>Event Permissions</b></div>
        </div>
        <div [ngClass]="no_animate ? 'nope' : privileges_open ? 'expand' : 'collapse'" [@drop]="no_animate ? 'nope' : privileges_open ? 'expand' : 'collapse' " class="privileges_area ">

              <mat-radio-group name="level" class="level_group align_options_top" (change)="dispatchPermissions()" [(ngModel)]="permissions_model" required>
                <ng-container *ngFor="let level of selectable_permission_levels">
                  <mat-radio-button *ngIf="level.handle !== 'program' || readState === 'Program'" disableRipple="true" color="primary" class="level" [value]="level.handle" [disabled]="level.disabled">
                      <div class="label"><b>{{level.label}}</b></div>
                      <div class="desc">{{level.desc}}</div>
                  </mat-radio-button>
                </ng-container>
              </mat-radio-group>

        </div>
      </div>
    </div>
    <div *ngIf="workforceService.errorMessage" class="errorMessage">
        <icon (click)="workforceService.errorMessage = ''" class="close" matIcon="close"></icon>
        <div>{{workforceService.errorMessage}}</div>
    </div>
</div>
